import magnificPopup from 'magnific-popup/dist/jquery.magnific-popup.min.js';
jQuery(function () {
  jQuery('.popup-modal').magnificPopup({
    type: 'inline',
    closeOnBgClick: true
  });
  jQuery(document).on('click', '.popup-close', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});